import _axios, {authUrl} from '../axios';

export const updatePassword = async (data: {
  oldPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
}) => {
  return await _axios.post(`${authUrl}/update-password`, data);
};
